import "./Features.css";

const Features = () => {
  return (
    <section className="features-section py-5">
      <div className="container">
        <center><h2 className="section-title">Features</h2></center>
        <div className="row">
          <div className="col-md-4 mb-4">
            <div className="card feature-card h-100 align-items-center">
              <div className="card-body d-flex justify-content-center flex-column align-items-center">
                <div className="feature-icon mb-3">
                  <i className="fas fa-check-circle"></i>
                </div>
                <h5 className="card-title">Accurate & Fast</h5>
                {/* <p className="card-text text-center">
                  Standard BMI calculation with precise results
                </p> */}
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card feature-card h-100 align-items-center">
              <div className="card-body d-flex justify-content-center flex-column align-items-center">
                <div className="feature-icon mb-3">
                  <i className="fas fa-bolt"></i>
                </div>
                <h5 className="card-title">Best Diet Plans</h5>
                {/* <p className="card-text text-center">
                  Instant results with no waiting time
                </p> */}
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card feature-card h-100 align-items-center">
              <div className="card-body d-flex justify-content-center flex-column align-items-center">
                <div className="feature-icon mb-3">
                  <i className="fas fa-smile"></i>
                </div>
                <h5 className="card-title">Easy To Use</h5>
                {/* <p className="card-text text-center">User-friendly interface for everyone</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;